export class ProdutosModel {
    constructor(partial?: Partial<ProdutosModel>){
        Object.assign(this, partial);
    }
    id: number;
    nome: string;
    produto_tipo_ref: number
}
